"use client";

import { useTranslations } from "@/i18n/client";
import { countries, useGeo } from "@/i18n/routing";
import styles from "./GeoSelector.module.css";

export const GeoStatus = () => {
	const t = useTranslations();
	const { country, language } = useGeo();
	const realCountry = countries.find((c) => c.country === country);
	return (
		<span className={styles.geoStatus}>
			{t(`languages.${language}`)} / ({realCountry?.currency})
		</span>
	);
};
